
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const GasDistributionEfficiency = () => {
  return (
    <AnimatedCard 
      animation="fade-up" 
      delay={600}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Distribution Efficiency</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center p-6">
        <div className="relative h-36 w-36">
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="text-4xl font-bold text-amber-600">89.7%</p>
          </div>
          <svg className="h-full w-full" viewBox="0 0 100 100">
            <circle 
              cx="50" cy="50" r="45" 
              fill="none" 
              stroke="#e2e8f0" 
              strokeWidth="8"
            />
            <circle 
              cx="50" cy="50" r="45" 
              fill="none" 
              stroke="#F59E0B" 
              strokeWidth="8"
              strokeDasharray="283"
              strokeDashoffset="29"
              transform="rotate(-90 50 50)"
            />
          </svg>
        </div>
        <p className="text-sm text-gray-500 mt-4 text-center">
          Current gas distribution efficiency score
        </p>
      </CardContent>
    </AnimatedCard>
  );
};

export default GasDistributionEfficiency;
